import { COMPONENTS_TYPES } from '@monorepo/page';
import Logo from '../Logo';

const componentsMap = {
  [COMPONENTS_TYPES.LOGO]: Logo
};

export default componentsMap;
